import { FlatList, Text, View } from "react-native";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { MedicationItem } from "../organisms/MedicationItem";
import { usePendingMedicationSignatureWithOffline } from "app/features/offline/hooks/usePendingMedicationSignatureWithOffline";
import Pagination from "ui/molecules/pagination/Pagination";

export function PendingMedicationsSignatureTemplate() {
  const { data, isFetching, meta, handlePageChange } =
    usePendingMedicationSignatureWithOffline();

  return (
    <View>
      <FlatList
        contentContainerClassName="gap-2"
        data={data ?? []}
        keyExtractor={(item) => `${item.id}`}
        renderItem={({ item }) => <MedicationItem medication={item} />}
        ListEmptyComponent={
          !isFetching ? (
            <Text className="text-center">
              There are no medications awaiting signature for this resident.
            </Text>
          ) : (
            <LoadingSpinner />
          )
        }
      />
      {meta && data?.length > 0 ? (
        <Pagination meta={meta} onPageChange={handlePageChange} />
      ) : null}
    </View>
  );
}
